export const ROOT_PATH = "/";
export const LOGIN_PATH = `${ROOT_PATH}login`;
export const PROFILE_PATH = `${ROOT_PATH}profile`;

export const CHAT_PAGE_PATH = `${ROOT_PATH}chat`;

// error
export const PAGE_403_PATH = `${ROOT_PATH}403`;
export const PAGE_404_PATH = `${ROOT_PATH}404`;
export const PAGE_500_PATH = `${ROOT_PATH}500`;

// user
export const USER_LIST_PATH = `${ROOT_PATH}user-list`;
export const ADD_USER_PATH = `${ROOT_PATH}add-user`;
export const EDIT_USER_PATH = `${ROOT_PATH}edit-user`;

// role
export const ROLE_LIST_PATH = `${ROOT_PATH}role-list`;
export const ADD_ROLE_PATH = `${ROOT_PATH}add-role`;
export const EDIT_ROLE_PATH = `${ROOT_PATH}edit-role`;

// static page
export const STATIC_PAGE_LIST_PATH = `${ROOT_PATH}static-page-list`;
export const ADD_STATIC_PAGE_PATH = `${ROOT_PATH}add-static-page`;
export const EDIT_STATIC_PAGE_PATH = `${ROOT_PATH}edit-static-page`;

// site config
export const SITE_CONFIG_LIST_PATH = `${ROOT_PATH}site-config-list`;
export const ADD_SITE_CONFIG_PATH = `${ROOT_PATH}add-site-config`;
export const EDIT_SITE_CONFIG_PATH = `${ROOT_PATH}edit-site-config`;

// banner
export const BANNER_LIST_PATH = `${ROOT_PATH}banner-list`;
export const ADD_BANNER_PATH = `${ROOT_PATH}add-banner`;
export const EDIT_BANNER_PATH = `${ROOT_PATH}edit-banner`;

// whyChooseUs
export const WHYCHOOSEUS_LIST_PATH = `${ROOT_PATH}whyChooseUs-list`;
export const ADD_WHYCHOOSEUS_PATH = `${ROOT_PATH}add-whyChooseUs`;
export const EDIT_WHYCHOOSEUS_PATH = `${ROOT_PATH}edit-whyChooseUs`;

// pricing
export const PRICING_LIST_PATH = `${ROOT_PATH}pricing-list`;
export const ADD_PRICING_PATH = `${ROOT_PATH}add-pricing`;
export const EDIT_PRICING_PATH = `${ROOT_PATH}edit-pricing`;

// instructors
export const INSTRUCTORS_LIST_PATH = `${ROOT_PATH}instructors-list`;
export const ADD_INSTRUCTORS_PATH = `${ROOT_PATH}add-instructors`;
export const EDIT_INSTRUCTORS_PATH = `${ROOT_PATH}edit-instructors`;

// contact
export const CONTACT_LIST_PATH = `${ROOT_PATH}contact-list`;

// about
export const ABOUT_LIST_PATH = `${ROOT_PATH}about-list`;
export const ADD_ABOUT_PATH = `${ROOT_PATH}add-about`;
export const EDIT_ABOUT_PATH = `${ROOT_PATH}edit-about`;

// gallery
export const GALLERY_LIST_PATH = `${ROOT_PATH}gallery-list`;
export const ADD_GALLERY_PATH = `${ROOT_PATH}add-gallery`;
export const EDIT_GALLERY_PATH = `${ROOT_PATH}edit-gallery`;

// faq
export const FAQ_LIST_PATH = `${ROOT_PATH}faq-list`;
export const ADD_FAQ_PATH = `${ROOT_PATH}add-faq`;
export const EDIT_FAQ_PATH = `${ROOT_PATH}edit-faq`;

// products
export const PRODUCTS_LIST_PATH = `${ROOT_PATH}products-list`;
export const ADD_PRODUCTS_PATH = `${ROOT_PATH}add-products`;
export const EDIT_PRODUCTS_PATH = `${ROOT_PATH}edit-products`;

// category
export const CATEGORY_LIST_PATH = `${ROOT_PATH}category-list`;
export const ADD_CATEGORY_PATH = `${ROOT_PATH}add-category`;
export const EDIT_CATEGORY_PATH = `${ROOT_PATH}edit-category`;

// managingSupplyChain
export const MANAGINGSUPPLYCHAIN_LIST_PATH = `${ROOT_PATH}managingSupplyChain-list`;
export const ADD_MANAGINGSUPPLYCHAIN_PATH = `${ROOT_PATH}add-managingSupplyChain`;
export const EDIT_MANAGINGSUPPLYCHAIN_PATH = `${ROOT_PATH}edit-managingSupplyChain`;

// news
export const NEWS_LIST_PATH = `${ROOT_PATH}news-list`;
export const ADD_NEWS_PATH = `${ROOT_PATH}add-news`;
export const EDIT_NEWS_PATH = `${ROOT_PATH}edit-news`;

// pressRelease
export const PRESSRELEASE_LIST_PATH = `${ROOT_PATH}pressRelease-list`;
export const ADD_PRESSRELEASE_PATH = `${ROOT_PATH}add-pressRelease`;
export const EDIT_PRESSRELEASE_PATH = `${ROOT_PATH}edit-pressRelease`;

// blog
export const BLOG_LIST_PATH = `${ROOT_PATH}blog-list`;
export const ADD_BLOG_PATH = `${ROOT_PATH}add-blog`;
export const EDIT_BLOG_PATH = `${ROOT_PATH}edit-blog`;

// videos
export const VIDEOS_LIST_PATH = `${ROOT_PATH}videos-list`;
export const ADD_VIDEOS_PATH = `${ROOT_PATH}add-videos`;
export const EDIT_VIDEOS_PATH = `${ROOT_PATH}edit-videos`;

// brands
export const BRANDS_LIST_PATH = `${ROOT_PATH}brands-list`;
export const ADD_BRANDS_PATH = `${ROOT_PATH}add-brands`;
export const EDIT_BRANDS_PATH = `${ROOT_PATH}edit-brands`;

// certificates
export const CERTIFICATES_LIST_PATH = `${ROOT_PATH}certificates-list`;
export const ADD_CERTIFICATES_PATH = `${ROOT_PATH}add-certificates`;
export const EDIT_CERTIFICATES_PATH = `${ROOT_PATH}edit-certificates`;

// challenges
export const CHALLENGES_LIST_PATH = `${ROOT_PATH}challenges-list`;
export const ADD_CHALLENGES_PATH = `${ROOT_PATH}add-challenges`;
export const EDIT_CHALLENGES_PATH = `${ROOT_PATH}edit-challenges`;

// solutions
export const SOLUTIONS_LIST_PATH = `${ROOT_PATH}solutions-list`;
export const ADD_SOLUTIONS_PATH = `${ROOT_PATH}add-solutions`;
export const EDIT_SOLUTIONS_PATH = `${ROOT_PATH}edit-solutions`;

// services
export const SERVICES_LIST_PATH = `${ROOT_PATH}services-list`;
export const ADD_SERVICES_PATH = `${ROOT_PATH}add-services`;
export const EDIT_SERVICES_PATH = `${ROOT_PATH}edit-services`;

// testimonial
export const TESTIMONIAL_LIST_PATH = `${ROOT_PATH}testimonial-list`;
export const ADD_TESTIMONIAL_PATH = `${ROOT_PATH}add-testimonial`;
export const EDIT_TESTIMONIAL_PATH = `${ROOT_PATH}edit-testimonial`;

// conclusion
export const CONCLUSION_LIST_PATH = `${ROOT_PATH}conclusion-list`;
export const ADD_CONCLUSION_PATH = `${ROOT_PATH}add-conclusion`;
export const EDIT_CONCLUSION_PATH = `${ROOT_PATH}edit-conclusion`;

// rnd
export const RND_LIST_PATH = `${ROOT_PATH}rnd-list`;
export const ADD_RND_PATH = `${ROOT_PATH}add-rnd`;
export const EDIT_RND_PATH = `${ROOT_PATH}edit-rnd`;

// toolRoom
export const TOOLROOM_LIST_PATH = `${ROOT_PATH}toolRoom-list`;
export const ADD_TOOLROOM_PATH = `${ROOT_PATH}add-toolRoom`;
export const EDIT_TOOLROOM_PATH = `${ROOT_PATH}edit-toolRoom`;

// job
export const JOB_LIST_PATH = `${ROOT_PATH}job-list`;
export const ADD_JOB_PATH = `${ROOT_PATH}add-job`;
export const EDIT_JOB_PATH = `${ROOT_PATH}edit-job`;

// xclusive
export const XCLUSIVE_LIST_PATH = `${ROOT_PATH}xclusive-list`;
export const ADD_XCLUSIVE_PATH = `${ROOT_PATH}add-xclusive`;
export const EDIT_XCLUSIVE_PATH = `${ROOT_PATH}edit-xclusive`;

// qpail
export const QPAIL_LIST_PATH = `${ROOT_PATH}qpail-list`;
export const ADD_QPAIL_PATH = `${ROOT_PATH}add-qpail`;
export const EDIT_QPAIL_PATH = `${ROOT_PATH}edit-qpail`;

// ourStory
export const OURSTORY_LIST_PATH = `${ROOT_PATH}ourStory-list`;
export const ADD_OURSTORY_PATH = `${ROOT_PATH}add-ourStory`;
export const EDIT_OURSTORY_PATH = `${ROOT_PATH}edit-ourStory`;

// ourBusiness
export const OURBUSINESS_LIST_PATH = `${ROOT_PATH}ourBusiness-list`;
export const ADD_OURBUSINESS_PATH = `${ROOT_PATH}add-ourBusiness`;
export const EDIT_OURBUSINESS_PATH = `${ROOT_PATH}edit-ourBusiness`;

// members
export const MEMBERS_LIST_PATH = `${ROOT_PATH}members-list`;
export const ADD_MEMBERS_PATH = `${ROOT_PATH}add-members`;
export const EDIT_MEMBERS_PATH = `${ROOT_PATH}edit-members`;

// qualityAssurance
export const QUALITYASSURANCE_LIST_PATH = `${ROOT_PATH}qualityAssurance-list`;
export const ADD_QUALITYASSURANCE_PATH = `${ROOT_PATH}add-qualityAssurance`;
export const EDIT_QUALITYASSURANCE_PATH = `${ROOT_PATH}edit-qualityAssurance`;

// ourStrength
export const OURSTRENGTH_LIST_PATH = `${ROOT_PATH}ourStrength-list`;
export const ADD_OURSTRENGTH_PATH = `${ROOT_PATH}add-ourStrength`;
export const EDIT_OURSTRENGTH_PATH = `${ROOT_PATH}edit-ourStrength`;

// valueProposition
export const VALUEPROPOSITION_LIST_PATH = `${ROOT_PATH}valueProposition-list`;
export const ADD_VALUEPROPOSITION_PATH = `${ROOT_PATH}add-valueProposition`;
export const EDIT_VALUEPROPOSITION_PATH = `${ROOT_PATH}edit-valueProposition`;

// navigationMenu
export const NAVIGATIONMENU_LIST_PATH = `${ROOT_PATH}navigationMenu-list`;
export const ADD_NAVIGATIONMENU_PATH = `${ROOT_PATH}add-navigationMenu`;
export const EDIT_NAVIGATIONMENU_PATH = `${ROOT_PATH}edit-navigationMenu`;

// sustainability
export const SUSTAINABILITY_LIST_PATH = `${ROOT_PATH}sustainability-list`;
export const ADD_SUSTAINABILITY_PATH = `${ROOT_PATH}add-sustainability`;
export const EDIT_SUSTAINABILITY_PATH = `${ROOT_PATH}edit-sustainability`;

// caseStudies
export const CASESTUDIES_LIST_PATH = `${ROOT_PATH}caseStudies-list`;
export const ADD_CASESTUDIES_PATH = `${ROOT_PATH}add-caseStudies`;
export const EDIT_CASESTUDIES_PATH = `${ROOT_PATH}edit-caseStudies`;
// SLUGS_EXPORTS_AREA
